import React from "react";
import Modal from "react-bootstrap/Modal";
import AppStyles from "../../../config/styles";
import { Div } from "../../atoms/Div";
import SensitiveAreaImg from "../../../../src/images/sensitive_area_logo.svg";
import { AddChildCloseIcon } from "../../atoms/ConnectStories";
import closeIconblack from "../../../images/close-Icon-black.svg";

const styles = {
  modal: {
    margin: 0,
    padding: "1%",
  },
  textStyle: {
    justifyContent: "center",
    textAlign: "center",
  },
  viewstyle: {
    backgroundColor: "white",
    borderRadius: "12px",
    padding: "15px"
  },
  desstyle: {
    fontFamily: "Lato",
    fontSize: "18px",
    color: "black",
    marginTop: "15px",
    marginLeft: "20px",
    marginRight: "15px",
    textAlign: "center",
  },
  galleryviewstyle: {
    borderRadius: 8,
    backgroundColor: AppStyles.colors.COLOR_ORANGE,
    margin: "3% auto",
    textAlign: "center",
    padding: "2% 5%",
    minWidth: "175px",
    boxShadow: "rgba(199, 83, 0, 0.4) 0 2px 4px,rgba(199, 83, 0, 0.3) 0 7px 13px -3px,#C75300 0 -3px 0 inset",
  },
  gallerytextstyle: {
    color: AppStyles.colors.COLOR_WHITE,
    fontSize: "20px",
    fontFamily: "Lato-Bold",
    cursor: "pointer"
  },
  SensitiveAreaImg: {
    maxWidth: "20%",
    margin: "auto"
  }
};

function HideConnectModal({ show, onClose, onPrimary, warningText, primaryText }) {
  return (
    <Modal
      show={show}
      centered
      style={styles.modal}
      backdrop="static"
      keyboard={false}
      contentClassName="hide-connect-modal-centered"
    >
      <AddChildCloseIcon onClick={onClose}>
        <img src={closeIconblack} alt="Close" />
      </AddChildCloseIcon>
      <img src={SensitiveAreaImg} style={styles.SensitiveAreaImg} alt="Warning" />
      <div style={styles.viewstyle}>
        <Div flexdiv style={styles.textStyle}>
          <p style={styles.desstyle}>{warningText}</p>
        </Div>
        <Div flexdiv draftSaveButton onClick={onPrimary}>
          <div style={styles.galleryviewstyle}>
            <span style={styles.gallerytextstyle}>{primaryText}</span>
          </div>
        </Div>
      </div>
    </Modal>
  );
}

export default HideConnectModal;